import React, { useState } from 'react';
import { Button, Chip, Stack, TableCell, TableRow, Typography, alpha, useTheme } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import VisibilityIcon from '@mui/icons-material/Visibility';

import MonthlyAdditionModal from './MonthlyAdditionModal';
import PeriodDots from './PeriodDots';
import SsoExportModal from './SsoExportModal';
import { formatCurrency, monthLabel } from './utils';

export default function MonthRow({ month, index, onOpen }) {
  const theme = useTheme();
  const statusColor = month.isComplete ? theme.palette.success.main : theme.palette.warning.main;
  const [exportOpen, setExportOpen] = useState(false);
  const [additionOpen, setAdditionOpen] = useState(false);

  return (
    <>
      <TableRow
        hover
        sx={{
          bgcolor: index % 2 === 1 ? alpha(theme.palette.text.primary, 0.02) : 'transparent',
          borderLeft: `3px solid ${statusColor}`,
        }}
      >
        <TableCell sx={{ fontWeight: 600 }}>{monthLabel(month.year, month.month)}</TableCell>
        <TableCell align="right" sx={{ fontWeight: 700, color: 'primary.main', fontVariantNumeric: 'tabular-nums' }}>
          {formatCurrency(month.totalAmount)}
        </TableCell>
        <TableCell align="center">{month.dailyEmployeeCount} คน</TableCell>
        <TableCell align="center">{month.fulltimeEmployeeCount} คน</TableCell>
        <TableCell align="center">
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
            <PeriodDots periodsFound={month.periodsFound} />
            <Typography variant="caption" color="text.secondary">{month.periodsFound.length}/3</Typography>
          </Stack>
        </TableCell>
        <TableCell align="center">
          <Chip
            size="small"
            label={month.isComplete ? 'ครบ 3 งวด' : 'ไม่ครบ'}
            sx={{
              fontWeight: 600,
              bgcolor: alpha(statusColor, 0.12),
              color: month.isComplete ? 'success.main' : 'warning.main',
            }}
          />
        </TableCell>
        <TableCell align="center">
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="primary"
              startIcon={<VisibilityIcon fontSize="small" />}
              onClick={() => onOpen(month.year, month.month)}
            >
              รายละเอียด
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              startIcon={<RequestQuoteIcon fontSize="small" />}
              onClick={() => setExportOpen(true)}
            >
              ปกส.
            </Button>
            <Button
              size="small"
              variant="contained"
              color="warning"
              startIcon={<PersonAddIcon fontSize="small" />}
              onClick={() => setAdditionOpen(true)}
            >
              เพิ่มคน
            </Button>
          </Stack>
        </TableCell>
      </TableRow>
      <SsoExportModal open={exportOpen} onClose={() => setExportOpen(false)} year={month.year} month={month.month} />
      <MonthlyAdditionModal open={additionOpen} onClose={() => setAdditionOpen(false)} year={month.year} month={month.month} />
    </>
  );
}
